module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJEAAAAhCAIAAABWcN4BAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4gYRCwMeLcpUMgAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAABzSURBVGje7duxDYAwDEVBBzGIN8+IWYEiiIY6ki3dNVDn6XfJCPpYa0XE5SDaufdnzuksKsvM79/O2u7sH5Oy7EwzNEMzzdAMzTRDMzTTDM3QTDM0QzM00wzN0EwzNEMzzajmvZPqNqqdcdDYz2OwMw56ACBeCN5COHB2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/buttons_icons/window_button_down.png
// module id = 10
// module chunks = 0